import { Suspense } from 'react';
import { Outlet } from 'react-router';

import { LoadingState } from '@/components/common/LoadingState';

/**
 * 본문(Content/Body) — 라우트 전환 시 이 영역만 교체된다(Top·LeftNav·Footer 고정).
 * 폭은 워크스페이스 컨테이너(max-w-workspace 1440px), 여백은 상단 24~32 · 좌우 16~32.
 */
export function WorkspaceBody() {
  return (
    <main className="mx-auto w-full max-w-workspace flex-1 px-4 pt-6 pb-4 sm:px-8 sm:pt-8">
      <Suspense fallback={<LoadingState />}>
        <Outlet />
      </Suspense>
    </main>
  );
}
